import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

export const pageTitle = defineStyle({
  fontSize: '28px',
  lineHeight: 'normal',
  fontWeight: 400,
  color: 'presets.turquoise.100',
  zIndex: 1,
})

export const sectionHeader = defineStyle({
  fontWeight: 500,
  fontSize: '21px',
})

export const headerTheme = defineStyleConfig({
  baseStyle: {
    _dark: {
      color: 'white',
    },
  },
  variants: {
    pageTitle,
    sectionHeader,
  },
})
